const PURPLE = '#5236AB';

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
  },

  scroll: {
    flexGrow: 1,
    minHeight: 0,
    overflowY: 'auto',
    p: 0.5,
  },

  sectionDivider: {
    mb: 0.5,
    color: PURPLE,
    fontFamily: 'Source Sans Pro',
    fontWeight: 500,
    lineHeight: 1.25,
    '& .MuiDivider-wrapper': {
      width: '20%',
      m: 0,
      mx: 0.3,        
      px: 0,
      py: 0,
      fontSize: '0.95rem',
      lineHeight: 1.25,
    },
    '&::before, &::after': { borderTopColor: PURPLE },
  },

  row: {
    pl: 0,
    color: PURPLE,
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 1,
    cursor: 'default',
    overflow: 'visible',
    py: 0.25,
    minHeight: 'unset',
  },

  icon: { mr: 0.75, color: PURPLE },

  link: {
    fontFamily: 'Source Sans Pro',
    fontSize: '0.95rem',
    color: PURPLE,
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-block',
    userSelect: 'none',
    lineHeight: 1.25,
    '&:hover': { textDecoration: 'underline' },
    '&:focus-visible': { outline: '2px solid #5236AB99', outlineOffset: 2, borderRadius: 2 },
  },
};

export default styles;
